export const getModelModulo = () => ({
    iIdModulo: 0,
    sNombre: "",
});

export const getModelSubmodulo = () => ({
    iIdModulo: 0,
    iIdSubModulo: 0,
    sNombre: "",
});

export const getModelBoton = () => ({
    iIdModulo: 0,
    iIdSubModulo: 0,
    iIdBoton: 0,
    sNombre: "",
});

export const getFormModulo = () => ({
    txtIdModulo: {
        label: "ID de módulo:",
        required: false,
        value: "",
        error: false,
        message: "El ID del módulo es requerido",
    },
    txtNombre: {
        label: "Nombre de módulo:",
        required: true,
        value: "",
        error: false,
        message: "El nombre del módulo es requerido",
    },
});

export const getFormSubmodulo = () => ({
    txtIdModulo: {
        label: "ID de módulo:",
        required: false,
        value: "",
        error: false,
        message: "El ID del módulo es requerido",
    },
    txtIdSubmodulo: {
        label: "ID de submódulo:",
        required: false,
        value: "",
        error: false,
        message: "El ID del submódulo es requerido",
    },
    txtNombre: {
        label: "Nombre de submódulo:",
        required: true,
        value: "",
        error: false,
        message: "El nombre del submódulo es requerido",
    },
});

export const getFormBoton = () => ({
    txtIdModulo: {
        label: "ID de módulo:",
        required: false,
        value: "",
        error: false,
        message: "El ID del módulo es requerido",
    },
    txtIdSubmodulo: {
        label: "ID de submódulo:",
        required: false,
        value: "",
        error: false,
        message: "El ID del submódulo es requerido",
    },
    txtIdBoton: {
        label: "ID de botón:",
        required: false,
        value: "",
        error: false,
        message: "El ID del botón es requerido",
    },
    txtNombre: {
        label: "Nombre de botón:",
        required: true,
        value: "",
        error: false,
        message: "El nombre del botón es requerido",
    },
});
